module.exports = __webpack_public_path__ + "static/media/student25.d6bb5857.png";